import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import {
  IProps,
} from './interfaces';
import {
  Asset,
  AssetThumbnail,
  AssetTitle,
} from './styles';

const PrePostRollListItem: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    asset,
    isSelected,
    onSelect,
  } = props;

  return (
    <Asset>
      <Checkbox
        color="secondary"
        checked={isSelected}
        value={isSelected}
        onChange={() => onSelect(isSelected ? null : asset)}
      />
      <AssetThumbnail src={asset._source.thumbnailImageUrl} />
      <AssetTitle>
        {asset._source.title}
      </AssetTitle>
    </Asset>
  );
};

export default PrePostRollListItem;
